import { SagaIterator } from "redux-saga";
import { ApproveRejectExcessMoneyRefundRequest, CreateExcessMoneyRefundRequest, ExcessMoneyRefundTypes } from "./types";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { approveExcessMoneyRefundApi, createExcessMoneyRefundApi, rejectExcessMoneyRefundApi } from "./api";

function* createExcessMoneyRefund({ payload }: CreateExcessMoneyRefundRequest): SagaIterator {
    try {
        const response = yield call(createExcessMoneyRefundApi, payload);
        yield put({
            type: ExcessMoneyRefundTypes.CREATE_EXCESS_MONEY_REFUND_SUCCESS,
            payload: { data: response.data.data }
        })
    } catch (error: any) {
        yield put({
            type: ExcessMoneyRefundTypes.CREATE_EXCESS_MONEY_REFUND_ERROR,
            payload: { error: error }
        })
    }
}

function* approveExcessMoneyRefund({payload} : ApproveRejectExcessMoneyRefundRequest) : SagaIterator {
    try {
        const response = yield call (approveExcessMoneyRefundApi,payload);
        yield put ({
            type: ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_APPROVE_SUCCESS,
            payload : {data : response.data.data}
        })
    } catch (error:any) {
     yield put({
        type : ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_APPROVE_ERROR,
        payload : {error : error}
     })   
    }
}

function* rejectExcessMoneyRefund({payload} : ApproveRejectExcessMoneyRefundRequest) : SagaIterator {
    try {
        const response = yield call (rejectExcessMoneyRefundApi,payload);
        yield put ({
            type: ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_REJECT_SUCCESS,
            payload : {data : response.data.data}
        })
    } catch (error:any) {
     yield put({
        type : ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_REJECT_ERROR,
        payload : {error : error}
     })   
    }
}

export function* watchCreateExcessMoneyRefund(){
    yield takeEvery(ExcessMoneyRefundTypes.CREATE_EXCESS_MONEY_REFUND,createExcessMoneyRefund)
}

export function* watchApproveExcessMoneyRefund() {
    yield takeEvery(ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_APPROVE,approveExcessMoneyRefund)
}

export function* watchRejectExcessMoneyRefund() {
    yield takeEvery(ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_REJECT,rejectExcessMoneyRefund)
}

function* ExcessMoneyRefundSaga (){
    yield all([
        fork(watchCreateExcessMoneyRefund),
        fork(watchApproveExcessMoneyRefund),
        fork(watchRejectExcessMoneyRefund)
    ])
}

export default ExcessMoneyRefundSaga;
